import React, { useState, useContext, useEffect } from "react";
import "./thankYou.css"
import { useNavigate } from "react-router-dom";
import { Context } from "../../app";
import { Mixpanel } from "../../Mixpanel";


function ThankYou() {
    
    let shop = useContext(Context)

    let navigate = useNavigate()

    useEffect(()=>{
        shop.setCart([])
        shop.updateCart([])
        shop.setShowPages(false)
        Mixpanel.track("Purchase", {
            cart:shop.cart
        })
        shop.ReactPixel.track("Purchase")
        // const script = document.createElement('script');

        // script.innerHTML = "gtag('event', 'conversion', { 'send_to': 'AW-11320994708/iTTJCNrdyNsYEJTXopYq', 'transaction_id': '' });"
        // document.body.appendChild(script);

        // return () => {
        //     document.body.removeChild(script);
        // }
        
    },[])

    return(
        <div className="thankYou">
            <h1>Thanks for placing you pre-order with us</h1>
            <p>You should have gotten a payment confirmation from PayPal. Once we're ready to ship out all orders, you'll receive another email with your
                tracking details
            </p>
            <p>Feel free to reach out with questions via email at: info@myvigilapp.com</p>

            <button onClick={()=>window.location.href = "https://www.myvigilapp.com"} className="">Go Back home</button>
            <button onClick={()=>navigate("/")} className="">Go back to shop</button>
        </div>
    )
}

export default ThankYou